import { useMutation, useQueryClient } from 'react-query';
import { ErrorResponse } from 'react-router-dom';

import { UpdatePasswordResponse, updateUser, updateUserPassword, UserResponse } from '../lib/user';
import { ChangePasswordSchemaType } from '@/components/organisms/ChangePasswordForm/schema';
import { ProfileSchemaType } from '@/components/organisms/ProfileForm/schema';

export const useUpdateUserMutation = ({ onSuccess }: { onSuccess?: (response: UserResponse) => void }) => {
  const queryClient = useQueryClient();
  return useMutation<UserResponse, ErrorResponse, ProfileSchemaType>((params) => updateUser(params), {
    onSuccess: (data) => {
      queryClient.invalidateQueries();
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};

export const useUpdateUserPassword = ({ onSuccess }: { onSuccess?: (response: UpdatePasswordResponse) => void }) => {
  const queryClient = useQueryClient();
  return useMutation<UpdatePasswordResponse, ErrorResponse, ChangePasswordSchemaType>((params) => updateUserPassword(params), {
    onSuccess: (data) => {
      queryClient.invalidateQueries();
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};
